import type { SingleIconProps } from "./icon"

const SearchIcon = (props: SingleIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.63979 12.7796C5.42546 12.7796 4.23839 12.4195 3.22871 11.7448C2.21903 11.0702 1.43207 10.1113 0.967367 8.98939C0.50266 7.86749 0.381072 6.63298 0.617977 5.44198C0.854882 4.25098 1.43964 3.15697 2.29831 2.29831C3.15697 1.43964 4.25098 0.854882 5.44198 0.617977C6.63298 0.381072 7.86749 0.50266 8.98939 0.967367C10.1113 1.43207 11.0702 2.21903 11.7448 3.22871C12.4195 4.23839 12.7796 5.42546 12.7796 6.63979C12.7776 8.26756 12.1301 9.82808 10.9791 10.9791C9.82808 12.1301 8.26756 12.7776 6.63979 12.7796ZM6.63979 1.8644C5.69531 1.8644 4.77204 2.14447 3.98673 2.6692C3.20142 3.19393 2.58934 3.93974 2.22791 4.81233C1.86647 5.68492 1.7719 6.64509 1.95616 7.57143C2.14042 8.49776 2.59523 9.34866 3.26308 10.0165C3.93093 10.6844 4.78183 11.1392 5.70816 11.3234C6.6345 11.5077 7.59467 11.4131 8.46726 11.0517C9.33985 10.6902 10.0857 10.0782 10.6104 9.29286C11.1351 8.50755 11.4152 7.58428 11.4152 6.63979C11.4137 5.37372 10.9102 4.15992 10.0149 3.26468C9.11966 2.36943 7.90586 1.86585 6.63979 1.8644Z"
        fill="#6F787E"
      />
      <path
        d="M15.3086 14.3439L12.4052 11.4404C12.1136 11.7906 11.7908 12.1135 11.4406 12.4051L14.344 15.3085C14.4727 15.4328 14.645 15.5015 14.8239 15.5C15.0027 15.4984 15.1738 15.4267 15.3003 15.3002C15.4268 15.1737 15.4985 15.0026 15.5001 14.8237C15.5017 14.6449 15.4329 14.4725 15.3086 14.3439Z"
        fill="#6F787E"
      />
    </svg>
  )
}

export { SearchIcon }
